// extracted by mini-css-extract-plugin
export default {"container":"cXyxw8JMr","iconsContainerInner":"cuWwLhoUG","featuresContainer":"cXFybPc9f","iconContainer":"cXkXZ2Vl_","icon":"cDmlFNtnP"};